module.exports = __webpack_public_path__ + "img/M007_04_jrb-04.4e9992a3.jpg";